<template>
	<select
		:value="value"
		:id="id"
		:class="className"
		@change="({ target: { value } }) => $emit('change', value)"
	>
		<option value="ru">RU</option>
		<option value="en">EN</option>
		<option value="uk">UA</option>
		<option value="pl">PL</option>
		<option value="az">AZ</option>
		<option value="hy">ARM</option>
		<option value="he">HE</option>
		<option value="md">RO</option>
		<option value="fr">FR</option>
		<option value="es">ES</option>
		<option value="cs">CZ</option>
		<option value="de">DE</option>
		<option value="it">IT</option>
		<option value="tr">TR</option>
		<option value="el">EL</option>
	</select>
</template>

<script>
export default {
	props: ['className', 'id', 'value'],
}
</script>

<style></style>
